import { dcaBaseUrl } from './dca'

export const templatesUrl = `${dcaBaseUrl}/templates`
export const createTemplateUrl = `${dcaBaseUrl}/templates-create`
